import React from 'react'
import PropTypes from 'prop-types'
import { useViewport } from '@chilecompra/react-kit'
import { CircleSuccessIcon, Typography } from '@chilecompra/react-kit/components'
import { GridRow, GridColumn, LinkAddProduct, StatusWrapper } from './SearchGoodsAndServicesByCategory.styles'

/**
 * The SearchGoodsAndServicesByCategoryRow's component.
 */
const SearchGoodsAndServicesByCategoryRow = props => {
  const { categoryId, handleAdd, id, isAdded, name } = props

  const {
    size: { isTiny }
  } = useViewport()

  return (
    <GridRow
      alignItems="center"
      border={isAdded}
      textAlign={isTiny && 'center'}
      background={isAdded}
      margin="12px 0"
      padding="10px 5px"
    >
      <GridColumn xs={12} sm={3}>
        <StatusWrapper justifyContent={isTiny && 'center'}>
          {isAdded ? <CircleSuccessIcon /> : ''}
          <LinkAddProduct onClick={handleAdd(id, name, categoryId)}>
            {!isAdded ? '+ Agregar al listado' : '+ Agregar nuevamente'}
          </LinkAddProduct>
        </StatusWrapper>
      </GridColumn>
      <GridColumn xs={12} sm={2}>
        <Typography color="gray1" fontSize="12px" variant="body2">
          {id}
        </Typography>
      </GridColumn>
      <GridColumn xs={12} sm={7}>
        <Typography color="black1" fontSize="12px" variant="body2">
          {name}
        </Typography>
      </GridColumn>
    </GridRow>
  )
}

SearchGoodsAndServicesByCategoryRow.propTypes = {
  categoryId: PropTypes.number.isRequired,
  handleAdd: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
  isAdded: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired
}

export default SearchGoodsAndServicesByCategoryRow
